// Current Terms of Use / Privacy Policy version. Bump this whenever the legal
// text (auth:legal locale) changes materially — logged-in users who accepted an
// older version will then be re-prompted by the consent banner, and new consent
// records are tied to the version actually shown.
export const TERMS_VERSION = '2026-07-20';
